import React, { useState, useEffect, useMemo } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';
import Sidebar from '../../Components/Sidebar/Sidebar';
import axios from 'axios';
import { ensureProtocol } from '../../../config/backend';
import verificandoApp from '../../../FuncoesGerais/verificaApp';
import verificandoToken from '../../../FuncoesGerais/VerificarToken';
import {
  fetchOpcoesSidebar,
  fetchPermissoesUsuario,
  putPermissoesUsuario,
} from '../../../api/permissoesSidebar';
import { fetchGruposUsuarioAtivos } from '../../../api/gruposUsuario';
import './permissoesUsuario.css';

function filtrarUsuariosPermissoes(usuarios, grupos) {
  if (!Array.isArray(usuarios)) return [];
  if (!Array.isArray(grupos) || grupos.length === 0) return [];
  const codigosComPapelAnalista = new Set(
    grupos
      .filter((g) => {
        const p = String(g.papel || '').trim().toLowerCase();
        return p === 'analista' || p === 'administrador';
      })
      .map((g) => String(g.codigo || '').trim().toUpperCase())
  );
  return usuarios.filter((u) => {
    const situacao = String(u.USRSIT || '').trim().toUpperCase();
    const codGrupo = String(u.USRGRU || '').trim().toUpperCase();
    return situacao === 'A' && codigosComPapelAnalista.has(codGrupo);
  });
}

const ORDEM_BLOCOS = [
  'DASHBOARD', 'CADASTROS', 'INVENTARIO', 'CHAMADOS', 'REPOSITORIOS', 'WORKLOG',
  'DOCUMENTACAO', 'RELATORIOS', 'CONFIG', 'NOTIFICACOES', 'AJUDA',
];

const NOME_BLOCOS = {
  DASHBOARD: 'Dashboard', CADASTROS: 'Cadastros', INVENTARIO: 'Inventário',
  CHAMADOS: 'Chamados', REPOSITORIOS: 'Desenvolvimento', WORKLOG: 'Horas & Faturamento',
  DOCUMENTACAO: 'Documentação', RELATORIOS: 'Relatórios',
  CONFIG: 'Config', NOTIFICACOES: 'Notificações', AJUDA: 'Ajuda',
};

const BLOCO_REMAPE = {
  AUTOMACAO: 'CONFIG',
  WEBHOOKS: 'CONFIG',
  SLA: 'CONFIG',
};

const BLOCO_POR_CODIGO = {
  CADASTROS_CONFIG_EMPRESA: 'CONFIG',
  ADMINISTRACAO_EMPRESAS: 'CONFIG',
  CONFIG_SISTEMA: 'CONFIG',
  CONFIG_PERMISSOES_USUARIO: 'CONFIG',
  API_CHAVES: 'CONFIG',
  REPOSITORIOS_LISTA: 'REPOSITORIOS',
  WORKLOG_TIMESHEET: 'WORKLOG',
  WORKLOG_FATURAMENTO: 'WORKLOG',
  WORKLOG_TARIFAS: 'WORKLOG',
  MANUTENCAO_DOCUMENTAR: 'INVENTARIO',
  MANUTENCAO_HISTORICO: 'INVENTARIO',
  RELATORIOS_PAINEIS: 'RELATORIOS',
};

const SUBSECAO_POR_CODIGO = {
  CADASTROS_USUARIOS: 'Pessoas e acesso',
  CADASTROS_GRUPOS_USUARIO: 'Pessoas e acesso',
  CADASTROS_CATEGORIAS: 'Fluxo de chamados',
  CADASTROS_TIPOS_CHAMADO: 'Fluxo de chamados',
  CADASTROS_STATUS_CHAMADO: 'Fluxo de chamados',
  CADASTROS_CHAMADOS_AUTOMATICOS: 'Fluxo de chamados',
  CADASTROS_SISTEMAS: 'Catálogos',
  CADASTROS_EQUIPAMENTOS: 'Catálogos',
  CADASTROS_BASE_IA: 'Catálogos',
  RELATORIOS_COLAB: 'Gerenciais',
  RELATORIOS_TIPO: 'Gerenciais',
  RELATORIOS_GERAL: 'Gerenciais',
  RELATORIOS_CHAMADOS_ABERTOS: 'Exportação e análise',
  RELATORIOS_TEMPO_COLABORADOR: 'Exportação e análise',
  RELATORIOS_EMPRESA: 'Exportação e análise',
  RELATORIOS_PAINEIS: 'Painéis',
  CONFIG_SISTEMA: 'Sistema',
  CONFIG_PERMISSOES_USUARIO: 'Sistema',
  CADASTROS_CONFIG_EMPRESA: 'Empresa',
  ADMINISTRACAO_EMPRESAS: 'Empresa',
  AUTOMACAO: 'Integrações',
  WEBHOOKS: 'Integrações',
  API_CHAVES: 'Integrações',
  SLA: 'SLA',
};

const ORDEM_SUBSECOES = {
  CADASTROS: ['Pessoas e acesso', 'Fluxo de chamados', 'Catálogos', ''],
  RELATORIOS: ['Gerenciais', 'Exportação e análise', 'Painéis', ''],
  CONFIG: ['Sistema', 'Empresa', 'SLA', 'Integrações', ''],
};

const CODIGOS_FILHOS_BLOCO = {
  REPOSITORIOS: ['REPOSITORIOS_LISTA'],
  WORKLOG: ['WORKLOG_TIMESHEET', 'WORKLOG_FATURAMENTO', 'WORKLOG_TARIFAS'],
  CONFIG: ['AUTOMACAO', 'WEBHOOKS', 'API_CHAVES', 'SLA', 'CADASTROS_CONFIG_EMPRESA', 'ADMINISTRACAO_EMPRESAS'],
};

function ensureBloco(mapa, codigo, nome) {
  if (!mapa[codigo]) {
    mapa[codigo] = { codigo, nome: nome || NOME_BLOCOS[codigo] || codigo, itens: [] };
  } else if (nome) {
    mapa[codigo].nome = nome;
  }
}

function agruparOpcoesPorBloco(opcoes) {
  if (!Array.isArray(opcoes) || opcoes.length === 0) return [];
  const mapa = {};
  opcoes.forEach((o) => {
    const cod = o.codigo || '';
    const nomeLimpo = (o.nome || '').replace(/\s*\(bloco\)\s*$/i, '').trim();
    const itemNome = (o.nome || '').replace(/^[^→]*→\s*/i, '').trim() || o.nome;
    const subsecao = SUBSECAO_POR_CODIGO[cod] || '';

    if (cod.indexOf('_') === -1) {
      const remape = BLOCO_REMAPE[cod];
      if (remape) {
        ensureBloco(mapa, remape);
        mapa[remape].itens.push({ codigo: cod, nome: nomeLimpo || cod, subsecao });
      } else {
        ensureBloco(mapa, cod, nomeLimpo || NOME_BLOCOS[cod] || cod);
      }
    } else {
      const bloco = BLOCO_POR_CODIGO[cod] || cod.split('_')[0];
      ensureBloco(mapa, bloco);
      mapa[bloco].itens.push({ codigo: cod, nome: itemNome, subsecao });
    }
  });

  const incluirBloco = (b) => !!mapa[b];
  const ordenados = ORDEM_BLOCOS.filter(incluirBloco).map((b) => mapa[b]);
  const extras = Object.keys(mapa)
    .filter((k) => !ORDEM_BLOCOS.includes(k) && incluirBloco(k))
    .sort()
    .map((k) => mapa[k]);
  return [...ordenados, ...extras];
}

function agruparItensPorSubsecao(bloco) {
  const ordem = ORDEM_SUBSECOES[bloco.codigo];
  if (!ordem || !bloco.itens.length) return [{ subsecao: '', itens: bloco.itens }];
  const mapa = new Map();
  bloco.itens.forEach((item) => {
    const key = item.subsecao || '';
    if (!mapa.has(key)) mapa.set(key, []);
    mapa.get(key).push(item);
  });
  const grupos = [];
  ordem.forEach((s) => {
    if (mapa.has(s) && mapa.get(s).length) grupos.push({ subsecao: s, itens: mapa.get(s) });
  });
  mapa.forEach((itens, s) => {
    if (!ordem.includes(s) && itens.length) grupos.push({ subsecao: s, itens });
  });
  return grupos.length ? grupos : [{ subsecao: '', itens: bloco.itens }];
}

// Perfis-preset: allowlist de blocos. null = todos os blocos (Administrador).
const PERFIS = [
  { id: 'admin', nome: 'Administrador', icone: 'fa-user-shield', blocos: null },
  { id: 'analista', nome: 'Analista', icone: 'fa-user-gear', blocos: ['DASHBOARD', 'CHAMADOS', 'REPOSITORIOS', 'WORKLOG', 'RELATORIOS', 'DOCUMENTACAO', 'INVENTARIO', 'NOTIFICACOES', 'AJUDA'] },
  { id: 'suporte', nome: 'Suporte', icone: 'fa-headset', blocos: ['DASHBOARD', 'CHAMADOS', 'INVENTARIO', 'DOCUMENTACAO', 'NOTIFICACOES', 'AJUDA'] },
];

// Constrói um objeto de permissões a partir de uma allowlist de blocos.
function construirPermissoesPreset(blocos, blocosPermitidos) {
  const next = {};
  blocos.forEach((b) => {
    const on = blocosPermitidos === null || blocosPermitidos.includes(b.codigo);
    next[b.codigo] = on;
    b.itens.forEach((it) => { next[it.codigo] = on; });
    (CODIGOS_FILHOS_BLOCO[b.codigo] || []).forEach((c) => { next[c] = on; });
  });
  return next;
}

// Conta itens ativos de um bloco (inclui o próprio toggle do bloco quando sem itens).
function contarBloco(bloco, permissoes) {
  if (!permissoes) return { ativos: 0, total: 0 };
  if (bloco.itens.length === 0) {
    return { ativos: permissoes[bloco.codigo] === true ? 1 : 0, total: 1 };
  }
  const ativos = bloco.itens.filter((it) => permissoes[it.codigo] === true).length;
  return { ativos, total: bloco.itens.length };
}

function PermissoesUsuario() {
  const history = useHistory();
  const { id: idParam } = useParams();
  const [usuarios, setUsuarios] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [opcoes, setOpcoes] = useState([]);
  const [permissoes, setPermissoes] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [mensagem, setMensagem] = useState('');
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  const [buscaUsuario, setBuscaUsuario] = useState('');
  const [recolhidos, setRecolhidos] = useState(() => new Set());
  const [copiando, setCopiando] = useState(false);

  const usuariosLista = useMemo(() => filtrarUsuariosPermissoes(usuarios, grupos), [usuarios, grupos]);
  const usuarioLogadoId = parseInt(localStorage.getItem('codUsu') || '0', 10);

  const verificar = async () => {
    const resultado = await verificandoApp('ATENDENTE');
    if (!resultado) history.push('/');
  };

  const getBase = () => ensureProtocol(localStorage.getItem('ipBackend2') || '');
  const getToken = () => localStorage.getItem('token');

  useEffect(() => {
    verificar();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const loadUsers = async () => {
      const base = getBase();
      const token = getToken();
      if (!base || !token) return;
      try {
        const res = await axios.get(base + '/usuarios/todos', {
          headers: { Authorization: token },
          timeout: 10000,
        });
        setUsuarios(Array.isArray(res?.data) ? res.data : []);
      } catch (e) {
        setUsuarios([]);
      }
    };
    loadUsers();
  }, []);

  useEffect(() => {
    const loadGrupos = async () => {
      const list = await fetchGruposUsuarioAtivos();
      setGrupos(Array.isArray(list) ? list : []);
    };
    loadGrupos();
  }, []);

  useEffect(() => {
    const loadOpcoes = async () => {
      const list = await fetchOpcoesSidebar();
      setOpcoes(list);
    };
    loadOpcoes();
  }, []);

  useEffect(() => {
    if (!idParam) {
      setPermissoes(null);
      setUsuarioSelecionado(null);
      setLoading(false);
      return;
    }
    const uid = parseInt(idParam, 10);
    if (Number.isNaN(uid)) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setMensagem('');
    verificandoToken();
    const base = getBase();
    const token = getToken();
    const carregarUsuario = base && token
      ? axios.get(base + '/usuarios', { headers: { Authorization: token }, params: { codUsu: uid }, timeout: 8000 }).then((r) => r.data?.[0] || null)
      : Promise.resolve(null);
    Promise.all([fetchPermissoesUsuario(uid), carregarUsuario])
      .then(([data, user]) => {
        setPermissoes(data);
        const u = user || usuariosLista.find((x) => x.USUSEQ === uid) || usuarios.find((x) => x.USUSEQ === uid) || null;
        setUsuarioSelecionado(u);
      })
      .catch(() => {
        setMensagem('Erro ao carregar permissões deste usuário.');
        setPermissoes(null);
      })
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idParam, usuarios.length, usuariosLista.length]);

  const toggleBloco = (bloco, novoValor) => {
    if (permissoes == null) return;
    setPermissoes((prev) => {
      const next = { ...prev, [bloco.codigo]: novoValor };
      bloco.itens.forEach((item) => { next[item.codigo] = novoValor; });
      (CODIGOS_FILHOS_BLOCO[bloco.codigo] || []).forEach((c) => { next[c] = novoValor; });
      return next;
    });
  };

  const toggleItem = (codigoItem, codigoBloco) => {
    if (permissoes == null) return;
    setPermissoes((prev) => {
      const novoValor = !prev[codigoItem];
      const next = { ...prev, [codigoItem]: novoValor };
      if (novoValor === true && prev[codigoBloco] === false) next[codigoBloco] = true;
      return next;
    });
  };

  const blocos = useMemo(() => agruparOpcoesPorBloco(opcoes), [opcoes]);

  const totais = useMemo(() => {
    let ativos = 0; let total = 0;
    blocos.forEach((b) => { const c = contarBloco(b, permissoes); ativos += c.ativos; total += c.total; });
    return { ativos, total };
  }, [blocos, permissoes]);

  const aplicarPreset = (perfil) => {
    if (!blocos.length) return;
    setPermissoes(construirPermissoesPreset(blocos, perfil.blocos));
    setMensagem(`Perfil "${perfil.nome}" aplicado — revise e clique em Salvar.`);
  };

  const marcarTudo = (valor) => {
    if (!blocos.length) return;
    setPermissoes(construirPermissoesPreset(blocos, valor ? null : []));
  };

  const toggleRecolhido = (codigo) => {
    setRecolhidos((prev) => {
      const next = new Set(prev);
      if (next.has(codigo)) next.delete(codigo); else next.add(codigo);
      return next;
    });
  };
  const recolherTudo = (recolher) => {
    setRecolhidos(recolher ? new Set(blocos.map((b) => b.codigo)) : new Set());
  };

  const copiarDeUsuario = async (outroUid) => {
    if (!outroUid) return;
    setCopiando(true);
    setMensagem('');
    try {
      const data = await fetchPermissoesUsuario(parseInt(outroUid, 10));
      if (data) {
        setPermissoes(data);
        const origem = usuariosLista.find((x) => String(x.USUSEQ) === String(outroUid));
        setMensagem(`Permissões copiadas de ${origem ? (origem.USRNOMCPL || origem.USRLGN) : 'usuário'} — revise e Salve.`);
      }
    } catch (_) {
      setMensagem('Não foi possível copiar as permissões desse usuário.');
    } finally { setCopiando(false); }
  };

  const salvar = async () => {
    const uid = parseInt(idParam, 10);
    if (Number.isNaN(uid) || permissoes == null) return;
    setSaving(true);
    setMensagem('');
    verificandoToken();
    try {
      await putPermissoesUsuario(uid, permissoes);
      setMensagem('Permissões salvas com sucesso.');
    } catch (e) {
      setMensagem(e?.response?.data?.error || e?.response?.data?.message || 'Erro ao salvar.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Sidebar />
      <main className="permissoes-usuario-page">
        <header className="permissoes-usuario-header">
          <h1>Permissões do menu (sidebar)</h1>
          <p className="permissoes-usuario-desc">
            Defina quais opções do menu lateral cada usuário pode ver. Apenas ADM/SUP podem alterar.
          </p>
        </header>

        {!idParam ? (
          <section className="permissoes-usuario-lista">
            <h2>Selecione um usuário</h2>
            <p className="permissoes-usuario-desc-lista">Listados apenas usuários ativos cujo grupo tem papel <strong>Analista</strong> ou <strong>Administrador</strong>.</p>
            <div className="perm-busca">
              <i className="fas fa-search" />
              <input
                type="text"
                className="perm-busca-input"
                placeholder="Buscar usuário por nome ou login…"
                value={buscaUsuario}
                onChange={(e) => setBuscaUsuario(e.target.value)}
              />
            </div>
            {usuarios.length === 0 ? (
              <p className="permissoes-usuario-msg">Carregando usuários...</p>
            ) : (() => {
              const q = buscaUsuario.trim().toLowerCase();
              const filtrados = q
                ? usuariosLista.filter((u) => `${u.USRNOMCPL || ''} ${u.USRLGN || ''}`.toLowerCase().includes(q))
                : usuariosLista;
              if (usuariosLista.length === 0) return <p className="permissoes-usuario-msg erro">Nenhum usuário ativo com grupo de papel Analista ou Administrador.</p>;
              if (filtrados.length === 0) return <p className="permissoes-usuario-msg">Nenhum usuário encontrado para “{buscaUsuario}”.</p>;
              return (
                <ul className="perm-user-list">
                  {filtrados.map((u) => (
                    <li key={u.USUSEQ}>
                      <button type="button" className="perm-user-card" onClick={() => history.push('/permissoes-usuario/' + u.USUSEQ)}>
                        <span className="perm-user-avatar">{(u.USRNOMCPL || u.USRLGN || '?').charAt(0).toUpperCase()}</span>
                        <span className="perm-user-info">
                          <span className="perm-user-nome">{u.USRNOMCPL || u.USRLGN || ('Usuário #' + u.USUSEQ)}{Number(u.USUSEQ) === usuarioLogadoId ? ' (você)' : ''}</span>
                          <span className="perm-user-meta">{u.USRLGN ? '@' + u.USRLGN : ''}{u.USRGRU ? ` · ${u.USRGRU}` : ''}</span>
                        </span>
                        <i className="fas fa-chevron-right perm-user-seta" />
                      </button>
                    </li>
                  ))}
                </ul>
              );
            })()}
          </section>
        ) : (
          <section className="permissoes-usuario-form">
            <Link to="/permissoes-usuario" className="permissoes-usuario-voltar">
              ← Voltar à lista
            </Link>
            {loading && <p>Carregando...</p>}
            {!loading && permissoes != null && blocos.length > 0 && (
              <div className="perm-edit">
                <div className="perm-edit-main">
                  <div className="perm-edit-toolbar">
                    <div className="perm-edit-toolbar-grp">
                      <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => marcarTudo(true)}>Marcar tudo</button>
                      <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => marcarTudo(false)}>Limpar tudo</button>
                    </div>
                    <div className="perm-edit-toolbar-grp">
                      <button type="button" className="btn btn-sm btn-link" onClick={() => recolherTudo(false)}>Expandir</button>
                      <button type="button" className="btn btn-sm btn-link" onClick={() => recolherTudo(true)}>Recolher</button>
                    </div>
                  </div>

                  <div className="permissoes-usuario-blocos">
                    {blocos.map((bloco) => {
                      const c = contarBloco(bloco, permissoes);
                      const recolhido = recolhidos.has(bloco.codigo);
                      const parcial = c.ativos > 0 && c.ativos < c.total;
                      return (
                        <div key={bloco.codigo} className={`permissoes-bloco-card ${c.ativos > 0 ? 'tem-ativo' : ''}`}>
                          <div className="permissoes-bloco-header">
                            <label className="permissoes-bloco-label">
                              <input
                                type="checkbox"
                                checked={permissoes[bloco.codigo] === true || c.ativos === c.total && c.total > 0}
                                ref={(el) => { if (el) el.indeterminate = parcial; }}
                                onChange={(e) => toggleBloco(bloco, e.target.checked)}
                              />
                              <span className="permissoes-bloco-nome">{bloco.nome}</span>
                            </label>
                            <span className="perm-bloco-contador">{c.ativos}/{c.total}</span>
                            {bloco.itens.length > 0 && (
                              <button type="button" className="perm-bloco-toggle" onClick={() => toggleRecolhido(bloco.codigo)} aria-label="Recolher bloco">
                                <i className={`fas fa-chevron-${recolhido ? 'down' : 'up'}`} />
                              </button>
                            )}
                          </div>
                          {bloco.itens.length > 0 && !recolhido && (
                            <div className="permissoes-bloco-itens">
                              {agruparItensPorSubsecao(bloco).map((grupo) => (
                                <div key={grupo.subsecao || '_geral'} className="permissoes-subsecao">
                                  {grupo.subsecao ? (
                                    <div className="permissoes-subsecao-titulo">{grupo.subsecao}</div>
                                  ) : null}
                                  {grupo.itens.map((item) => (
                                    <label key={item.codigo} className="permissoes-item-label">
                                      <input
                                        type="checkbox"
                                        checked={permissoes[item.codigo] === true}
                                        onChange={() => toggleItem(item.codigo, bloco.codigo)}
                                      />
                                      <span>{item.nome}</span>
                                    </label>
                                  ))}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>

                <aside className="perm-edit-resumo">
                  <div className="perm-resumo-card">
                    <div className="perm-resumo-user">
                      <span className="perm-user-avatar lg">{((usuarioSelecionado && (usuarioSelecionado.USRNOMCPL || usuarioSelecionado.USRLGN)) || '?').charAt(0).toUpperCase()}</span>
                      <div>
                        <div className="perm-resumo-nome">{usuarioSelecionado ? (usuarioSelecionado.USRNOMCPL || usuarioSelecionado.USRLGN) : 'Usuário'}</div>
                        {usuarioSelecionado && usuarioSelecionado.USRLGN && <div className="perm-resumo-login">@{usuarioSelecionado.USRLGN}</div>}
                      </div>
                    </div>
                    <div className="perm-resumo-total">
                      <strong>{totais.ativos}</strong> de {totais.total} permissões ativas
                    </div>
                  </div>

                  <div className="perm-resumo-card">
                    <div className="perm-resumo-titulo">Aplicar perfil</div>
                    <div className="perm-presets">
                      {PERFIS.map((p) => (
                        <button key={p.id} type="button" className="perm-preset-btn" onClick={() => aplicarPreset(p)}>
                          <i className={`fas ${p.icone} me-2`} />{p.nome}
                        </button>
                      ))}
                    </div>
                    <p className="perm-resumo-hint">Define um conjunto base; ajuste os itens depois.</p>
                  </div>

                  <div className="perm-resumo-card">
                    <div className="perm-resumo-titulo">Copiar de outro usuário</div>
                    <select className="form-control form-control-sm" defaultValue="" disabled={copiando}
                      onChange={(e) => { copiarDeUsuario(e.target.value); e.target.value = ''; }}>
                      <option value="">{copiando ? 'Copiando…' : 'Selecione um usuário…'}</option>
                      {usuariosLista.filter((u) => String(u.USUSEQ) !== String(idParam)).map((u) => (
                        <option key={u.USUSEQ} value={u.USUSEQ}>{u.USRNOMCPL || u.USRLGN}</option>
                      ))}
                    </select>
                  </div>

                  <button type="button" className="btn btn-primary perm-resumo-salvar" onClick={salvar} disabled={saving}>
                    {saving ? 'Salvando...' : 'Salvar permissões'}
                  </button>
                  {mensagem && <p className={`permissoes-usuario-msg ${mensagem.includes('sucesso') || mensagem.includes('aplicado') || mensagem.includes('copiad') ? 'sucesso' : 'erro'}`}>{mensagem}</p>}
                </aside>
              </div>
            )}
            {!loading && permissoes == null && idParam && (
              <p className="permissoes-usuario-msg erro">Não foi possível carregar as permissões.</p>
            )}
          </section>
        )}
      </main>
    </>
  );
}

export default PermissoesUsuario;
